import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "col" }
const _hoisted_2 = { class: "row w-full" }
const _hoisted_3 = { class: "mleft-auto" }
const _hoisted_4 = { class: "row w-full mtop-04" }
const _hoisted_5 = {
  key: 0,
  class: "subGrid"
}
const _hoisted_6 = { style: {"grid-column":"left"} }
const _hoisted_7 = { style: {"grid-column":"middle"} }
const _hoisted_8 = {
  style: {"grid-column":"right"},
  class: "row"
}
const _hoisted_9 = { class: "bg-blue-04 pad-m rnd-m mtop-20 w-full" }

import { ref, computed, PropType } from 'vue';
import { useI18n } from 'vue-i18n';
import { apiAmountCurrency} from '@/api/apicommon';
import officeapi from '@/api/officeapi';
import { DateFormat } from '@/models/share.model';
import { format } from 'date-fns';
import PersonService from "@/services/PersonService";

type TpType = 'tp' | 'tpSocial';


export default /*@__PURE__*/_defineComponent({
  __name: 'createTiersPayant',
  props: {
  selectedInvoices: {
    type: Array,
    required: true,
  },
  tpType: {
    type: String as PropType<TpType>,
    required: true,
    validator: (value: string) => ['tp', 'tpSocial'].includes(value)
  }
},
  emits: ['reload'],
  setup(__props, { emit: __emit }) {

const { t } = useI18n();

const props = __props

const emits = __emit

const tiersPayantDate = ref(new Date());

function updateDate(newDate: Date) {
  tiersPayantDate.value = newDate;
}

const sheetTitle = computed(() => {
  return props.tpType === 'tpSocial' 
    ? t('accounting.financialGroupMenu.channelActions.createLuTpSocialSheet')
    : t('accounting.financialGroupMenu.channelActions.createLuTpSheet');
})

async function createTpSheet() {
  const invoiceIds = props.selectedInvoices.map(invoice => invoice.id)
  const sheetDateISO = format(tiersPayantDate.value, DateFormat.ISO_SMALL);
  if (props.tpType === 'tpSocial') {
    await officeapi.createTpSocialSheet(invoiceIds, sheetDateISO)
  } else {
    await officeapi.createTpSheet(invoiceIds, sheetDateISO)
  }
  
  emits("reload")
}

function getPersonName(invoice: any) {
  const pwr = invoice.pwrCounterParty;
  return PersonService.formatName(pwr.lastName, pwr.firstName);
}

return (_ctx: any,_cache: any) => {
  const _component_text_item = _resolveComponent("text-item")!
  const _component_button_group = _resolveComponent("button-group")!
  const _component_esInputDateTime = _resolveComponent("esInputDateTime")!

  return (_openBlock(), _createElementBlock("div", {
    class: "bg-modal row w-maxC gap-20",
    onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_text_item, {
          txt: sheetTitle.value,
          styles: "font-l"
        }, null, 8, ["txt"]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_button_group, {
            styles: "border-h pad-s",
            class: "psides-06",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (createTpSheet()))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_text_item, {
                txt: _unref(t)('action.create'),
                styles: "font-mBold"
              }, null, 8, ["txt"])
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_text_item, {
          txt: "Facture(s):",
          styles: "font-mBold main-m"
        }),
        _createVNode(_component_text_item, {
          txt: __props.selectedInvoices.length.toString(),
          styles: "font-mBold main-m",
          class: "mleft-04"
        }, null, 8, ["txt"])
      ]),
      (__props.selectedInvoices.length < 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.selectedInvoices, (invoice, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_text_item, {
                    txt: getPersonName(invoice),
                    styles: "main-m"
                  }, null, 8, ["txt"])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_text_item, {
                    txt: invoice.invoiceReference,
                    styles: "main-m"
                  }, null, 8, ["txt"])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_text_item, {
                    txt: _unref(apiAmountCurrency)(invoice.partial, invoice.currencyIso),
                    class: "mleft-auto",
                    styles: "main-h"
                  }, null, 8, ["txt"])
                ])
              ], 64))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_esInputDateTime, {
          inline: "",
          dateTimeValue: new Date(),
          dateFormat: _unref(DateFormat).DATEPICKER,
          range: false,
          withTime: false,
          onUpdateDateTime: _cache[1] || (_cache[1] = ($event: any) => (updateDate($event)))
        }, null, 8, ["dateTimeValue", "dateFormat"])
      ])
    ])
  ]))
}
}

})